//write Dispatch functions here
import { connect } from "react-redux";
import { withSnackbar } from "react-simple-snackbar";
//set redux state variables as prop
function mapStateToProps(state) {
    return {
      lang: state.lang,
      drawerShown: state.drawerShown,
      donationOpen: state.donationOpen,
      langSelectorOpen: state.langSelectorOpen,
      okDialogShown: state.okDialogShown,
      okDialogMessage: state.okDialogMessage,
      isAuth: state.isAuth,
      userData: state.userData,
      loading: state.loading,
      selectedHotelId: state.selectedHotelId,
      accessControl: state.accessControl,
      subscriptionActive: state.subscriptionActive,
      hotels: state.hotels,
      hotelSelectedId: state.hotelSelectedId,
      pendingBookingCount: state.pendingBookingCount,
      pendingPickupCount: state.pendingPickupCount,
      dineInCount: state.dineInCount,
      paymentRequestCount: state.paymentRequestCount,
      receiptFooter: state.receiptFooter, // Add this line
    };
}

//action functions to update redux state value
function mapDispatchToProps(dispatch) {
    return {
      setPendingBookingCount: (val) =>
        dispatch({ type: "SET_PENDING_BOOKING_COUNT", value: val }),

      setPendingPickupCount: (val) =>
        dispatch({ type: "SET_PENDING_PICKUP_COUNT", value: val }),

      setDineInCount: (val) =>
        dispatch({ type: "SET_DINE_IN_COUNT", value: val }),

      setPaymentRequestCount: (val) =>
        dispatch({ type: "SET_PAYMENT_REQUEST_COUNT", value: val }),

      setHotelSelectedId: (value) =>
        dispatch({ type: "SET_HOTEL_SELECTED_ID", value }),
      setHotels: (value) => dispatch({ type: "SET_HOTELS", value }),
      setSubscriptionActive: (value) =>
        dispatch({ type: "SET_SUBSCRIPTION_ACTIVE", value }),
      setAccessControl: (value) =>
        dispatch({ type: "SET_ACCESS_CONTROL", value }),
      logout: () => dispatch({ type: "LOGOUT" }),
      setSelectedHotelId: (value) =>
        dispatch({ type: "SET_SELECTED_HOTEL_ID", value }),
      setLanguage: (value) => dispatch({ type: "SET_LANGUAGE", value }),
      setDrawerShown: (value) => dispatch({ type: "setDrawerShown", value }),
      setDonationOpen: (value) => dispatch({ type: "setDonationOpen", value }),
      setLangSelectorOpen: (value) =>
        dispatch({ type: "setLangSelectorOpen", value }),
      setOkDialogMessage: (value) =>
        dispatch({ type: "setOkDialogMessage", value }),

      setOkDialogShown: (value) =>
        dispatch({ type: "setOkDialogShown", value }),
      setAuth: (value) => dispatch({ type: "SET_AUTH", value }),
      setUser: (value) => dispatch({ type: "SET_USER", value }),
      setLoading: (value) => dispatch({ type: "setLoading", value }),
      // In your mapDispatchToProps function
      setReceiptFooter: (value) => dispatch({ type: "SET_RECEIPT_FOOTER", value }),
          };
}

const snakeOptions = {
    position: "top-center", //top-left, top-center, top-right, bottom-left, bottom-center and bottom-right.
    style: {
        backgroundColor: "midnightblue",
        border: "2px solid gray",
        color: "lightblue",
        fontFamily: "poppins",
        fontSize: "20px",
        textAlign: "center",
    },
    closeStyle: {
        color: "lightcoral",
        fontSize: "16px",
    },
};

export default (screen) =>
    withSnackbar(
        connect(mapStateToProps, mapDispatchToProps)(screen),
        snakeOptions
    );
